export default __webpack_public_path__ + "static/media/fusion-011.49955167.svg";